<template>
  <v-col cols="4">
    <v-autocomplete
      :items="stops"
      :rules="[required]"
      item-value="short_name"
      :item-text="item => `(${item.short_name}) ${item.stop_name}`"
      :filter="
        (item, query) =>
          item.short_name.toLowerCase().includes(query.toLowerCase()) ||
          item.stop_name.toLowerCase().includes(query.toLowerCase())
      "
      outlined
      label="Plats"
      v-model="model.location"
    />
  </v-col>
</template>

<script>
import { required } from '@/common/validationRules'
import { get, sync } from 'vuex-pathify'

export default {
  name: 'TurnaroundLocationField',

  data: () => ({
    required
  }),

  computed: {
    stops: get('event/stops'),
    model: sync('turnaround/model')
  }
}
</script>
